/**
 * Labstep
 *
 * @module state/epics/entity
 * @desc Redux epic for entity actions
 */

import type { Action } from 'labstep-web/models/action.model';
import { createEntity } from 'labstep-web/state/actions/entity';
import { selectCreateEntityAllStatuses } from 'labstep-web/state/selectors/entity';
import type { StateObservable } from 'redux-observable';
import { concat, type Observable, of } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';

/**
 * Send request
 *
 * @function
 * @param  {Observable<Action>} action$
 * @param  {StateObservable<LabstepReduxState>} state$
 * @return {Observable<Action>}
 */
export const createEntityIfNotCreatingActionEpic = (
  action$: Observable<Action>,
  state$: StateObservable<any>,
): Observable<Action> =>
  action$.pipe(
    filter(
      (action: Action) =>
        action.type.includes('CHECK_CREATING_ON_CREATE_ENTITY') &&
        selectCreateEntityAllStatuses(
          state$.value,
          (action.payload as any).entityName as string,
        ).every((status) => !status.isFetching),
    ),
    map((action: Action) => {
      return createEntity(
        (action.payload as any).entityName as string,
        (action.payload as any).data as any,
        (action.payload as any).parentName as string,
        (action.payload as any).parentId as number,
        (action.payload as any).uuid as string,
        (action.payload as any).options as any,
        (action.payload as any).childKeyName as string,
      );
    }),
    catchError((err, source$: Observable<Action>) =>
      concat(
        of({
          type: 'EPIC_FAIL_CREATE_ENTITY_IF_NOT_CREATING',
          payload: err,
        }),
        source$,
      ),
    ),
  );
